import React from "react";
import {Pagination, PaginationItem, PaginationLink} from "reactstrap";

export const PaginationControls = (props) => {
  let {currentPage, elements, setCurrentPage} = props;

    const handlePageClick = async (e, index) => {
        e.preventDefault();
        setCurrentPage(index);
    };

    return (
        <Pagination size="lg">
            <PaginationItem>
                <PaginationLink
                    first
                    href="#"
                    onClick={e => handlePageClick(e, 0)}
                />
            </PaginationItem>
            <PaginationItem disabled={currentPage === 0}>
                <PaginationLink
                    href="#"
                    previous
                    onClick={e => handlePageClick(e, currentPage - 1)}

                />
            </PaginationItem>
            {elements && [...Array(elements.pageCount)].map((page, i) => (
                <PaginationItem active={i === currentPage} key={i}>
                    <PaginationLink onClick={e => handlePageClick(e, i)} href="#">
                        {i + 1}
                    </PaginationLink>
                </PaginationItem>
            ))}
            <PaginationItem disabled={elements && currentPage === elements.pageCount - 1}>
                <PaginationLink
                    href="#"
                    next
                    onClick={e => handlePageClick(e, currentPage + 1)}
                />
            </PaginationItem>
            <PaginationItem>
                <PaginationLink
                    href="#"
                    last
                    onClick={e => handlePageClick(e, elements.pageCount - 1)}
                />
            </PaginationItem>
        </Pagination>
    );
};

export default PaginationControls;
